module.exports = __webpack_public_path__ + "img/top.5f5a3eed.svg";